import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定银行卡界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Account  from '../pages/mine/Account'/* 账户详情 */


Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'Meeting'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'Meeting'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'Meeting'}},
	{path:'/List',name:'list',component:List,meta:{title:'Meeting'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'Meeting'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'Meeting'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'Meeting'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'Meeting'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'Meeting'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'Meeting'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'Meeting'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'Meeting'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'Meeting'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Meeting'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'Meeting'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'Meeting'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'Meeting'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'Meeting'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Meeting'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Meeting'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Meeting'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'Meeting'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Meeting'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Meeting'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Meeting'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'Meeting'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'Meeting'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Meeting'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Meeting'}},
    {path:'/Account',name:'Account',component:Account,meta:{title:'Meeting'}},


];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    document.title = to.matched[0].meta.title
    next()
})

export default router